<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="700px"
    :before-close="close"
    title="修改密码"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item
        label="旧密码"
        label-width="120px"
        prop="old_password"
        show-password
      >
        <el-input
          v-model="form.old_password"
          auto-complete="off"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="新密码"
        label-width="120px"
        prop="password1"
        show-password
      >
        <el-input
          v-model="form.password1"
          auto-complete="off"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="确认密码"
        label-width="120px"
        prop="password2"
        show-password
      >
        <el-input
          v-model="form.password2"
          auto-complete="off"
          type="password"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      dialogFormVisible: true,
      form: {
        old_password: "",
        password1: "",
        password2: ""
      },
      step: 1,
      rules: {
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        password1: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        password2: [
          { required: true, message: "请确认新密码", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        let form = Object.assign({}, this.form);
        let methods = "put";
        let url = "password/";

        this.$http[methods](url, form, data => {
          this.$baseNotice.message(data.msg);
          this.$emit("close");
        });
      });
    }
  }
};
</script>
